interface Props {
  value: number | string
}

export const SliderTertiaryLabel = ({ value }: Props) => {
  return (
    <div className="font-mediums text-sm text-content-subdued">{value}</div>
  )
}
